export default __webpack_public_path__ + "static/salesforce-5ad560fcb1072df0edc1011291035ef9.svg";